import { SvgIcon, type SvgIconProps } from '@mui/material';

const UsdtTrc20Icon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox='0 0 64 64'>
    <circle cx='24' cy='28' r='18' fill='#26A17B' />
    <path
      d='M24 14c-8 0-14.5 6.5-14.5 14.5S16 43 24 43s14.5-6.5 14.5-14.5S32 14 24 14Zm7.5 9.5h-5.2v3c4.5.2 7.9 1.1 7.9 2.1 0 1.1-3.4 2-7.9 2.2v9.2h-4.6v-9.2c-4.7-.1-8.3-1-8.3-2.2 0-1.1 3.6-1.9 8.3-2.1v-3h-5.2v-4.1h15Z'
      fill='#FFF'
    />
    <circle cx='42' cy='24' r='10' fill='#EF4444' />
    <path d='m42 18 4.8 9h-9.6L42 18Zm0 3.7-1.7 3.3h3.5L42 21.7Z' fill='#FFF' />
    <rect x='25' y='38' width='30' height='12' rx='3' fill='#F3F4F6' />
    <text x='40' y='47' textAnchor='middle' fontSize='10' fontWeight='700' fill='#111827'>
      TRC20
    </text>
  </SvgIcon>
);

export default UsdtTrc20Icon;
